module.exports = __webpack_public_path__ + "static/media/boat-night.3a52c04f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/boat-night.mp3
// module id = 1298
// module chunks = 0